import { Controller } from 'stimulus'
import {
  assetHasTranscript,
  normalizeAssetId,
} from './lesson_tabs_helpers'

export default class extends Controller {
  static targets = [
    'courseTab',
    'transcriptTab',
    'assetTranscript',
    'assetBookmarks',
    'panelContainer',
  ]

  static values = {
    assetIdsWithTranscript: Array,
    currentLessonId: Number,
    expandModuleId: Number,
  }

  initialize() {
    this.lastScrollPositionByTab = {}
    this.courseScrollDone = false
  }

  assetChanged(e) {
    // Stimulus params and some event paths pass string ids; the Array value is
    // numeric JSON. Normalize so includes() / comparisons don't hide the tab.
    const assetId = normalizeAssetId(e.detail.assetId)
    if (assetId == null) return

    this.assetTranscriptTargets.forEach((transcript) => {
      transcript.classList.toggle(
        'hidden',
        normalizeAssetId(transcript.dataset.transcriptAssetId) !== assetId
      )
    })
    this.assetBookmarksTargets.forEach((bookmarks) => {
      bookmarks.classList.toggle(
        'hidden',
        normalizeAssetId(bookmarks.dataset.bookmarksAssetId) !== assetId
      )
    })
    this.#showOrHideTranscriptTab(assetId)
    this.#showOrHideBookmarksTab(assetId)
  }

  saveScrollPosition(e) {
    const tab = e.detail.currentlyActiveTab
    const tabId = tab.dataset.lessonTab
    this.lastScrollPositionByTab[tabId] = this.panelContainerTarget.scrollTop
  }

  lazyContentLoaded() {
    this.scrollToCurrentLesson()
  }

  restoreScrollPosition(e) {
    const tab = e.detail.tab
    const tabId = tab.dataset.lessonTab
    const lastPosition = this.lastScrollPositionByTab[tabId]
    if (lastPosition || lastPosition === 0) {
      setTimeout(() => {
        this.panelContainerTarget.scrollTop = lastPosition
      }, 0)
    }
    if (tabId === 'course_overview' && !this.courseScrollDone) {
      requestAnimationFrame(() => this.scrollToCurrentLesson())
    }
  }

  scrollToCurrentLesson() {
    if (this.courseScrollDone) return
    const lessonId = this.currentLessonIdValue
    if (!lessonId) return
    const lessonEl = document.querySelector(
      `.js-course-lesson[data-id="${lessonId}"]`
    )
    if (!lessonEl) return
    const panel =
      lessonEl.closest('[data-tabs-target="panel"]') ||
      lessonEl.closest('.overflow-y-auto, .overflow-auto')
    if (!panel || !panel.offsetHeight) return
    this.courseScrollDone = true
    const moduleId = this.expandModuleIdValue
    const moduleEl = moduleId
      ? document.getElementById(`course_module_${moduleId}`)
      : null
    const panelRect = panel.getBoundingClientRect()
    if (moduleEl)
      panel.scrollTop += moduleEl.getBoundingClientRect().top - panelRect.top
    const lessonRect = lessonEl.getBoundingClientRect()
    if (lessonRect.top < panelRect.top) {
      panel.scrollTop += lessonRect.top - panelRect.top
    } else if (lessonRect.bottom > panelRect.bottom) {
      panel.scrollTop += lessonRect.bottom - panelRect.bottom
    }
  }

  tabActivated(e) {
    const tab = e.currentTarget
    const tabId = tab.dataset.lessonTab
    window.UserPreference?.set('default_lesson_tab', tabId)
  }

  #showOrHideTranscriptTab(assetId) {
    if (!this.hasTranscriptTabTarget) return

    const hasTranscript = assetHasTranscript(
      assetId,
      this.assetIdsWithTranscriptValue
    )

    this.transcriptTabTarget.classList.toggle('hidden', !hasTranscript)

    if (
      this.transcriptTabTarget.classList.contains('t-tab-active') &&
      !hasTranscript
    )
      this.courseTabTarget.click()
  }

  #showOrHideBookmarksTab(_assetId) {
    // Bookmarks tab target/value were never fully wired. Do not change
    // visibility on play until membership can be computed correctly.
  }
}
